










































































import { mapClassifiedTypeToGA4, pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import Vue from "vue";
import { mapGetters } from "vuex";
import { Trans } from "@/shared/scripts/helpers/translation/translation";
import { getClassifiedId } from "@/shared/scripts/ClassifiedsApi";
import iwEstimationToolBanner from "@/shared/components/EstimationToolBanner.vue";
import thor from "@sl/thor";
import { pushHotjarQRDetails } from "@/shared/scripts/helpers/hotjar/hotjarUtils";
import {pushRefinerDetails} from "@/shared/scripts/helpers/refiner/refinerUtils";
import iwTrustPilotWidget from "@/shared/components/TrustPilotWidget.vue";

export default Vue.extend({
    components: {
        iwEstimationToolBanner: iwEstimationToolBanner,
        iwTrustPilotWidget: iwTrustPilotWidget
    },

    data: function() {
        return {
            showBanner: false,
        };
    },

    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading",
        }),

        action: function(): string {
            return this.$route.query.action as string;
        },

        isPublication: function(): boolean {
            return this.action === "PUBLICATION";
        },

        isOptimized: function(): boolean {
            return this.$route.query.optimized === "true";
        },

        classifiedId: function(): string {
            return this.$route.params.id as string;
        },

        homePageUrl: function(): string {
            return `${process.env.VUE_APP_IMMOWEB_URL}/${Trans.currentLocale}`;
        },

        currentLanguage: function(): string {
            return Trans.currentLocale;
        }
    },

    mounted: function() {
        this.fireDepositEvents();

        if (document.readyState === "complete") {
            this.fetchAndTrack();
        } else {
            window.addEventListener("load", () => {
                this.fetchAndTrack();
            });
        }

    },

    methods: {
        fetchAndTrack: function() {
            Vue.nextTick(() => {
                getClassifiedId(this.$router.currentRoute.params.id).then(() => {
                    // GA4
                    if (!this.isOptimized) {
                        pushPageViewEvent("classified_deposit_confirmation");
                    } else {
                        pushPageViewEvent("classified_deposit_v2_step10_confirmation");
                    }

                    this.handleBannerVisibility();
                    pushHotjarQRDetails();
                    pushRefinerDetails();
                });
            });
        },
        handleBannerVisibility: function() {
            const pricingType = this.action;
            const order = this.$store.state.OrdersModule.currentOrder;
            const propertyType = order?.tariff?.propertyType;
            const transactionType = order?.tariff?.transactionType;
            this.showBanner = (transactionType === "FOR_SALE" &&
                (propertyType === "APARTMENT" || propertyType === "HOUSE") &&
                (pricingType === "PUBLICATION" || pricingType === "EXTENSION" || pricingType === "RENEWAL"));
        },
        fireDepositEvents: function() {
            const order = this.$store.state.OrdersModule.currentOrder;
            if (!order?.tariff) {
                return;
            }
            const transactionType = order.tariff.transactionType;
            const propertyType = order.tariff.propertyType;
            const payload = {
                "av_feature": "classified_deposit",
                "av_user": {
                    "project": transactionType === "FOR_SALE" ? "WantsToSell" : "WantsToRent",
                },
                "av_distribution_type_global": transactionType === "FOR_SALE" ? "2" : "1",
                "av_estate_type_global": mapClassifiedTypeToGA4(propertyType),
                "av_distribution_subtype": transactionType === "FOR_SALE" ? "2" : "1",
            };

            thor.pushEvent("classified_deposit_submit", payload);
            thor.pushEvent("classified_deposit_confirmation", payload);
        },
        navigateToClassified: function(legacyId: string) {
            const url = `${process.env.VUE_APP_IMMOWEB_URL}/${this.currentLanguage}/${this.$t("classified")}/${legacyId}`;
            window.location.href = url;
        },

        seeImmowebPage: function() {
            const tryNavigate = () => {
                const classifiedData = this.$store.getters["MyClassifiedsModule/getMyClassifiedSelected"];

                if (classifiedData?.legacyId) {
                    this.navigateToClassified(classifiedData.legacyId);
                    return true;
                }
                return false;
            };

            // Try to navigate with existing data first
            if (tryNavigate()) {
                return;
            }

            // If no legacyId, fetch classified data and try again
            getClassifiedId(this.classifiedId)
                .then((success) => {
                    if (success && !tryNavigate()) {
                        console.error("Failed to get legacyId after API call");
                    }
                })
                .catch(error => {
                    console.error("Failed to load classified data:", error);
                });
        },
    }
});

